<template>
  <v-app
    id="main"
    :style="{ background: $vuetify.theme.themes[theme].background }"
    class="pa-0 ma-0"
  >
    <sabira_nav v-if="$store.getters.user !== null"></sabira_nav>
    <v-main>
      <sabira_header v-if="$store.getters.user !== null"></sabira_header>
      <router-view />
    </v-main>
    <v-snackbar
      top
      :timeout="status.timeout"
      v-model="show_status"
      :color="status.type"
      rounded
    >
      <v-icon left large>{{
        status.type == "error" ? "mdi-alert" : "mdi-check-bold"
      }}</v-icon>

      {{ status.message }}
    </v-snackbar>
    <v-snackbar
      top
      :timeout="status.timeout"
      v-model="show_calendar"
      :color="status.type"
      rounded
      :multi-line="multiLine"
    >
      <v-icon left large>{{
        status.type == "error" ? "mdi-alert" : "mdi-information-outline"
      }}</v-icon>

      {{ status.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="secondary darken-2"
          text
          @click="show_calendar = false"
          :multi-line="multiLine"
          v-bind="attrs"
        >
          Zatvori
        </v-btn>
      </template>
    </v-snackbar>
    <sabira_klijent v-if="show_klijent" :id="selected_id"></sabira_klijent>
    <sabira_user v-if="show_user" :id="selected_id"></sabira_user>
    <sabira_faktura
      v-if="show_faktura"
      :visible="show_faktura"
      :default="selected_object"
    ></sabira_faktura>
    <sabira_product v-if="show_product" :id="selected_id"></sabira_product>
    <sabira_account
      close="close_account"
      v-if="show_account"
      :id="selected_id"
    ></sabira_account>
    <sabira_admin_account
      close="close_admin_account"
      v-if="show_admin_account"
      :id="selected_id"
    ></sabira_admin_account>
    <sabira_contract v-if="show_contract" :id="selected_id"></sabira_contract>
    <sabira_payment v-if="show_payment" :id="selected_id"></sabira_payment>
    <sabira_expense v-if="show_expense" :id="selected_id"></sabira_expense>
    <sabira_offer
      v-if="show_offer"
      :visible="show_offer"
      :id="selected_id"
    ></sabira_offer>
    <sabira_settings
      close="close_settings"
      v-if="show_settings"
      :id="selected_id"
      :visible="show_settings"
    ></sabira_settings>
    <sabira_warehouse
      close="close_warehouse"
      v-if="show_warehouse"
      :id="selected_id"
      :visible="show_warehouse"
    ></sabira_warehouse>
    <sabira_user_settings
      close="close_user_settings"
      v-if="show_user_settings"
      :id="selected_id"
      :visible="show_user_settings"
    ></sabira_user_settings>
    <sabira_supplier v-if="show_supplier" :id="selected_id"></sabira_supplier>
    <sabira_department
      v-if="show_department"
      :id="selected_id"
      :visible="show_department"
    ></sabira_department>
    <sabira_employee
      v-if="show_employee"
      :id="selected_id"
      :visible="show_employee"
    ></sabira_employee>
    <sabira_salary
      v-if="show_salary"
      :id="selected_id"
      :visible="show_salary"
    ></sabira_salary>
    <sabira_expense_payment
      v-if="show_expense_payment"
      :id="selected_id"
    ></sabira_expense_payment>
    <sabira_sys_message_dialog
      v-if="show_sys_message_dialog"
      :id="selected_id"
    ></sabira_sys_message_dialog>
    <sabira_user_messages
      v-if="show_user_messages"
      :id="selected_id"
      :visible="show_user_messages"
      close="close_user_messages"
    >
    </sabira_user_messages>
    <sabira_message
      close="close_message"
      v-if="show_message"
      :id="selected_id"
      :visible="show_message"
    ></sabira_message>
    <sabira_new_note_dialog
      close="close_new_note_dialog"
      v-if="show_new_note_dialog"
      :id="selected_id"
      :visible="show_new_note_dialog"
    ></sabira_new_note_dialog>
    <sabira_asset v-if="show_asset" :id="selected_id"></sabira_asset>
    <sabira_employee_time_sheet
      v-if="show_employee_time_sheet"
      :id="selected_id"
      :visible="show_employee_time_sheet"
    ></sabira_employee_time_sheet>
    <sabira_position
      v-if="show_position"
      :id="selected_id"
      :visible="show_position"
    ></sabira_position>
    <sabira_pr_goals
      v-if="show_pr_goals"
      :id="selected_id"
      :visible="show_pr_goals"
    ></sabira_pr_goals>
    <sabira_password_email
      v-if="show_password_email"
      :visible="show_password_email"
    ></sabira_password_email>
    <sabira_reset_dialog
      v-if="show_reset_dialog"
      :visible="show_reset_dialog"
    ></sabira_reset_dialog>
    <sabira_new_pass_dialog
      v-if="show_new_pass_dialog"
      :visible="show_new_pass_dialog"
      :email="new_pass_email"
    ></sabira_new_pass_dialog>
    <sabira_pr v-if="show_pr" :id="selected_id" :visible="show_pr"></sabira_pr>
    <sabira_responsibilities
      v-if="show_responsibilities"
      :id="selected_id"
      :visible="show_responsibilities"
    ></sabira_responsibilities>
    <sabira_work_order
      v-if="show_work_order"
      :id="selected_id"
      :visible="show_work_order"
    ></sabira_work_order>
    <sabira_stock_add
      v-if="show_stock_add"
      :id="selected_id"
      :visible="show_stock_add"
    ></sabira_stock_add>
    <sabira_order
      v-if="show_order"
      :id="selected_id"
      :visible="show_order"
    ></sabira_order>
    <sabira_dispatch_note
      v-if="show_dispatch_note"
      :id="selected_id"
      :faktura_id="selected_faktura_id"
      :visible="show_dispatch_note"
    ></sabira_dispatch_note>
    <sabira_return_stock
      v-if="show_return_stock"
      :id="selected_id"
      :visible="show_return_stock"
    ></sabira_return_stock>
    <sabira_stock_writeoff
      v-if="show_stock_writeoff"
      :id="selected_id"
      :visible="show_stock_writeoff"
    ></sabira_stock_writeoff>
    <sabira_calendar_event
      v-if="show_calendar_event"
      :id="selected_id"
      :visible="show_calendar_event"
    ></sabira_calendar_event>
    <sabira_stock_inventory
      v-if="show_stock_inventory"
      :id="selected_id"
      :visible="show_stock_inventory"
    ></sabira_stock_inventory>
    <sabira_ko_note
      v-if="show_ko_note"
      :id="selected_id"
      :visible="show_ko_note"
    ></sabira_ko_note>
    <sabira_category
      v-if="show_category"
      :id="selected_id"
      :visible="show_category"
    ></sabira_category>
    <sabira_support_ticket
      v-if="show_support_ticket"
      :id="selected_id"
      :visible="show_support_ticket"
    ></sabira_support_ticket>
    <sabira_categories_list
      v-if="show_categories_list"
      :visible="show_categories_list"
    ></sabira_categories_list>
    <sabira_departments_list
      v-if="show_departments_list"
      :visible="show_departments_list"
    ></sabira_departments_list>
    <sabira_responsibilities_list
      v-if="show_responsibilities_list"
      :visible="show_responsibilities_list"
    ></sabira_responsibilities_list>
    <sabira_responsibility_item
      v-if="show_responsibility_item"
      :id="selected_id"
      :visible="show_responsibility_item"
    ></sabira_responsibility_item>
    <sabira_campaign
      v-if="show_campaign"
      :id="selected_id"
      :visible="show_campaign"
    ></sabira_campaign>
    <sabira_marketing_budget
      v-if="show_marketing_budget"
      :id="selected_id"
      :visible="show_marketing_budget"
    ></sabira_marketing_budget>
    <sabira_memo
      v-if="show_memo"
      :id="selected_id"
      :visible="show_memo"
    ></sabira_memo>
    <sabira_pdv_calculator
      v-if="show_pdv_calculator"
      :visible="show_pdv_calculator"
    ></sabira_pdv_calculator>
  </v-app>
</template>

<script>
export default {
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  components: {
    sabira_nav: () => import("@/components/navigation"),
    sabira_header: () => import("@/components/header"),
    sabira_klijent: () => import("@/components/client"),
    sabira_faktura: () => import("@/components/invoice"),
    sabira_product: () => import("@/components/product"),
    sabira_user: () => import("@/components/user"),
    sabira_account: () => import("@/components/account"),
    sabira_admin_account: () => import("@/components/admin_account"),
    sabira_contract: () => import("@/components/contract"),
    sabira_payment: () => import("@/components/payment"),
    sabira_expense: () => import("@/components/expense"),
    sabira_offer: () => import("@/components/offer"),
    sabira_settings: () => import("@/components/account"),
    sabira_supplier: () => import("@/components/supplier"),
    sabira_user_settings: () => import("@/components/user_settings"),
    sabira_expense_payment: () => import("@/components/expense_payment"),
    sabira_sys_message_dialog: () => import("@/components/sys_message_dialog"),
    sabira_user_messages: () => import("@/components/user_messages"),
    sabira_message: () => import("@/components/message"),
    sabira_employee: () => import("@/components/employee"),
    sabira_new_note_dialog: () => import("@/components/new_note_dialog"),
    sabira_asset: () => import("@/components/asset"),
    sabira_employee_time_sheet: () =>
      import("@/components/employee_time_sheet"),
    sabira_position: () => import("@/components/position"),
    sabira_salary: () => import("@/components/salary"),
    sabira_pr: () => import("@/components/pr"),
    sabira_pr_goals: () => import("@/components/pr_goals"),
    sabira_password_email: () => import("@/components/password_email"),
    sabira_reset_dialog: () => import("@/components/reset_dialog"),
    sabira_new_pass_dialog: () => import("@/components/new_pass_dialog"),
    sabira_department: () => import("@/components/department"),
    sabira_responsibilities: () => import("@/components/responsibilities"),
    sabira_work_order: () => import("@/components/work_order"),
    sabira_stock_add: () => import("@/components/stock_add"),
    sabira_order: () => import("@/components/order"),
    sabira_dispatch_note: () => import("@/components/dispatch_note"),
    sabira_warehouse: () => import("@/components/warehouse"),
    sabira_stock_writeoff: () => import("@/components/stock_writeoff"),
    sabira_calendar_event: () => import("@/components/calendar_event"),
    sabira_return_stock: () => import("@/components/return_stock"),
    sabira_stock_inventory: () => import("@/components/stock_inventory"),
    sabira_ko_note: () => import("@/components/ko_note"),
    sabira_category: () => import("@/components/category"),
    sabira_categories_list: () => import("@/components/categories_list"),
    sabira_support_ticket: () => import("@/components/support_ticket"),
    sabira_departments_list: () => import("@/components/departments_list"),
    sabira_responsibilities_list: () =>
      import("@/components/responsibilities_list"),
    sabira_responsibility_item: () =>
      import("@/components/responsibility_item"),
    sabira_campaign: () => import("@/components/campaign"),
    sabira_marketing_budget: () => import("@/components/marketing_budget"),
    sabira_memo: () => import("@/components/memo"),
    sabira_pdv_calculator: () => import("@/components/pdv_calculator"),
  },
  data: () => ({
    drawer: true,
    group: null,
    selected_id: null,
    show_klijent: false,
    show_faktura: false,
    show_izvod: false,
    show_status: false,
    show_calendar: false,
    show_product: false,
    show_account: false,
    show_admin_account: false,
    show_user: false,
    show_contract: false,
    show_payment: false,
    show_expense: false,
    show_offer: false,
    show_settings: false,
    show_user_settings: false,
    show_supplier: false,
    show_employee: false,
    show_expense_payment: false,
    show_support_email: false,
    show_admin_email: false,
    show_sys_message_dialog: false,
    show_user_messages: false,
    show_message: false,
    show_new_note_dialog: false,
    show_asset: false,
    show_employee_time_sheet: false,
    show_position: false,
    show_salary: false,
    show_pr: false,
    show_pr_goals: false,
    show_password_email: false,
    show_reset_dialog: false,
    show_new_pass_dialog: false,
    selected_object: null,
    new_pass_email: null,
    show_department: false,
    show_responsibilities: false,
    show_work_order: false,
    show_stock_add: false,
    show_order: false,
    show_dispatch_note: false,
    show_warehouse: false,
    show_stock_writeoff: false,
    show_calendar_event: false,
    show_return_stock: false,
    show_stock_inventory: false,
    show_ko_note: false,
    show_category: false,
    show_categories_list: false,
    show_support_ticket: false,
    show_departments_list: false,
    show_responsibilities_list: false,
    show_responsibility_item: false,
    show_campaign: false,
    show_marketing_budget: false,
    show_memo: false,
    show_pdv_calculator: false,
    multiLine: true,
    status: {
      type: "success",
      message: null,
    },
  }),
  mounted() {
    this.$webpageEventBus.$on("show_klijent", (id) => {
      this.selected_id = id;
      this.show_klijent = true;
    });
    this.$webpageEventBus.$on("show_account", (id) => {
      this.selected_id = id;
      this.show_account = true;
    });
    this.$webpageEventBus.$on("show_admin_account", (id) => {
      this.selected_id = id;
      this.show_admin_account = true;
    });
    this.$webpageEventBus.$on("close_account", () => {
      this.show_account = false;
    });
    this.$webpageEventBus.$on("close_admin_account", () => {
      this.show_admin_account = false;
    });
    this.$webpageEventBus.$on("show_user", (id) => {
      this.selected_id = id;
      this.show_user = true;
    });
    this.$webpageEventBus.$on("close_klijent", () => {
      this.show_klijent = false;
    });
    this.$webpageEventBus.$on("close_product", () => {
      this.show_product = false;
    });
    this.$webpageEventBus.$on("close_user", () => {
      this.show_user = false;
    });
    this.$webpageEventBus.$on("show_faktura", (invoice) => {
      this.selected_object = invoice;
      this.show_faktura = true;
    });
    this.$webpageEventBus.$on("show_product", (id) => {
      this.selected_id = id;
      this.show_product = true;
    });
    this.$webpageEventBus.$on("close_faktura", () => {
      this.show_faktura = false;
    });
    this.$webpageEventBus.$on("show_contract", (id) => {
      this.selected_id = id;
      this.show_contract = true;
    });
    this.$webpageEventBus.$on("close_contract", () => {
      this.show_contract = false;
    });
    this.$webpageEventBus.$on("show_payment", (id) => {
      this.selected_id = id;
      this.show_payment = true;
    });
    this.$webpageEventBus.$on("close_payment", () => {
      this.show_payment = false;
    });
    this.$webpageEventBus.$on("show_expense", (id) => {
      this.selected_id = id;
      this.show_expense = true;
    });
    this.$webpageEventBus.$on("close_expense", () => {
      this.show_expense = false;
    });
    this.$webpageEventBus.$on("show_offer", (id) => {
      this.selected_id = id;
      this.show_offer = true;
    });
    this.$webpageEventBus.$on("close_offer", () => {
      this.show_offer = false;
    });

    this.$webpageEventBus.$on("show_settings", (id) => {
      this.selected_id = id;
      this.show_settings = true;
    });

    this.$webpageEventBus.$on("close_settings", () => {
      this.show_settings = false;
    });

    this.$webpageEventBus.$on("show_user_settings", (id) => {
      this.selected_id = id;
      this.show_user_settings = true;
    });

    this.$webpageEventBus.$on("close_user_settings", () => {
      this.show_user_settings = false;
    });
    this.$webpageEventBus.$on("show_supplier", (id) => {
      this.selected_id = id;
      this.show_supplier = true;
    });
    this.$webpageEventBus.$on("close_supplier", () => {
      this.show_supplier = false;
    });
    this.$webpageEventBus.$on("show_employee", (id) => {
      this.selected_id = id;
      this.show_employee = true;
    });
    this.$webpageEventBus.$on("close_employee", () => {
      this.show_employee = false;
    });
    this.$webpageEventBus.$on("show_expense_payment", (id) => {
      this.selected_id = id;
      this.show_expense_payment = true;
    });
    this.$webpageEventBus.$on("close_expense_payment", () => {
      this.show_expense_payment = false;
    });
    this.$webpageEventBus.$on("show_sys_message_dialog", (id) => {
      this.selected_id = id;
      this.show_sys_message_dialog = true;
    });
    this.$webpageEventBus.$on("close_sys_message_dialog", () => {
      this.show_sys_message_dialog = false;
    });
    this.$webpageEventBus.$on("show_user_messages", (id) => {
      this.selected_id = id;
      this.show_user_messages = true;
    });
    this.$webpageEventBus.$on("close_user_messages", () => {
      this.show_user_messages = false;
    });
    this.$webpageEventBus.$on("show_message", (id) => {
      this.selected_id = id;
      this.show_message = true;
    });
    this.$webpageEventBus.$on("close_message", () => {
      this.show_message = false;
    });
    this.$webpageEventBus.$on("show_new_note_dialog", (id) => {
      this.selected_id = id;
      this.show_new_note_dialog = true;
    });
    this.$webpageEventBus.$on("close_new_note_dialog", () => {
      this.show_new_note_dialog = false;
    });
    this.$webpageEventBus.$on("show_asset", (id) => {
      this.selected_id = id;
      this.show_asset = true;
    });
    this.$webpageEventBus.$on("close_asset", () => {
      this.show_asset = false;
    });
    this.$webpageEventBus.$on("show_employee_time_sheet", (id) => {
      this.selected_id = id;
      this.show_employee_time_sheet = true;
    });
    this.$webpageEventBus.$on("close_employee_time_sheet", () => {
      this.show_employee_time_sheet = false;
    });
    this.$webpageEventBus.$on("show_position", (id) => {
      this.selected_id = id;
      this.show_position = true;
    });
    this.$webpageEventBus.$on("close_position", () => {
      this.show_position = false;
    });
    this.$webpageEventBus.$on("show_salary", (id) => {
      this.selected_id = id;
      this.show_salary = true;
    });
    this.$webpageEventBus.$on("close_salary", () => {
      this.show_salary = false;
    });
    this.$webpageEventBus.$on("show_pr", (id) => {
      this.selected_id = id;
      this.show_pr = true;
    });
    this.$webpageEventBus.$on("close_pr", () => {
      this.show_pr = false;
    });
    this.$webpageEventBus.$on("show_pr_goals", (id) => {
      this.selected_id = id;
      this.show_pr_goals = true;
    });
    this.$webpageEventBus.$on("close_pr_goals", () => {
      this.show_pr_goals = false;
    });
    this.$webpageEventBus.$on("show_password_email", () => {
      this.show_password_email = true;
    });
    this.$webpageEventBus.$on("close_password_email", () => {
      this.show_password_email = false;
    });
    this.$webpageEventBus.$on("show_reset_dialog", () => {
      this.show_reset_dialog = true;
    });
    this.$webpageEventBus.$on("close_reset_dialog", () => {
      this.show_reset_dialog = false;
    });
    this.$webpageEventBus.$on("show_department", (id) => {
      this.show_department = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_department", () => {
      this.show_department = false;
    });
    this.$webpageEventBus.$on("show_responsibilities", (id) => {
      this.show_responsibilities = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_responsibilities", () => {
      this.show_responsibilities = false;
    });
    this.$webpageEventBus.$on("show_responsibilities_list", () => {
      this.show_responsibilities_list = true;
    });
    this.$webpageEventBus.$on("close_responsibilities_list", () => {
      this.show_responsibilities_list = false;
    });
    this.$webpageEventBus.$on("show_work_order", (id) => {
      this.show_work_order = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_work_order", () => {
      this.show_work_order = false;
    });
    this.$webpageEventBus.$on("show_order", (id) => {
      this.show_order = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_order", () => {
      this.show_order = false;
    });
    this.$webpageEventBus.$on("show_stock_writeoff", (id) => {
      this.show_stock_writeoff = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_stock_writeoff", () => {
      this.show_stock_writeoff = false;
    });
    this.$webpageEventBus.$on("show_calendar_event", (id) => {
      this.show_calendar_event = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_calendar_event", () => {
      this.show_calendar_event = false;
    });
    this.$webpageEventBus.$on("show_stock_add", (id) => {
      this.show_stock_add = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_stock_add", () => {
      this.show_stock_add = false;
    });
    this.$webpageEventBus.$on("show_dispatch_note", (id, faktura_id) => {
      this.show_dispatch_note = true;
      this.selected_id = id;
      this.selected_faktura_id = faktura_id;
    });
    this.$webpageEventBus.$on("close_dispatch_note", () => {
      this.show_dispatch_note = false;
    });
    this.$webpageEventBus.$on("show_return_stock", (id) => {
      this.show_return_stock = true;
      this.selected_id = id;
    });
    this.$webpageEventBus.$on("close_return_stock", () => {
      this.show_return_stock = false;
    });
    this.$webpageEventBus.$on("show_new_pass_dialog", (email) => {
      this.show_new_pass_dialog = true;
      this.new_pass_email = email;
    });
    this.$webpageEventBus.$on("close_new_pass_dialog", () => {
      this.show_new_pass_dialog = false;
    });
    this.$webpageEventBus.$on("show_warehouse", (id) => {
      this.selected_id = id;
      this.show_warehouse = true;
    });

    this.$webpageEventBus.$on("close_warehouse", () => {
      this.show_warehouse = false;
    });
    this.$webpageEventBus.$on("show_stock_inventory", (id) => {
      this.selected_id = id;
      this.show_stock_inventory = true;
    });
    this.$webpageEventBus.$on("close_stock_inventory", () => {
      this.show_stock_inventory = false;
    });
    this.$webpageEventBus.$on("show_ko_note", (id) => {
      this.selected_id = id;
      this.show_ko_note = true;
    });
    this.$webpageEventBus.$on("close_ko_note", () => {
      this.show_ko_note = false;
    });
    this.$webpageEventBus.$on("show_responsibility_item", (id) => {
      this.selected_id = id;
      this.show_responsibility_item = true;
    });
    this.$webpageEventBus.$on("close_responsibility_item", () => {
      this.show_responsibility_item = false;
    });
    this.$webpageEventBus.$on("show_category", (id) => {
      this.selected_id = id;
      this.show_category = true;
    });
    this.$webpageEventBus.$on("close_category", () => {
      this.show_category = false;
    });
    this.$webpageEventBus.$on("show_categories_list", () => {
      this.show_categories_list = true;
    });
    this.$webpageEventBus.$on("close_categories_list", () => {
      this.show_categories_list = false;
    });
    this.$webpageEventBus.$on("show_departments_list", () => {
      this.show_departments_list = true;
    });
    this.$webpageEventBus.$on("close_departments_list", () => {
      this.show_departments_list = false;
    });
    this.$webpageEventBus.$on("show_support_ticket", (id) => {
      this.selected_id = id;
      this.show_support_ticket = true;
    });
    this.$webpageEventBus.$on("close_support_ticket", () => {
      this.show_support_ticket = false;
    });
    this.$webpageEventBus.$on("show_status", (status) => {
      this.status.type = status.type;
      this.status.message = status.message;
      this.status.timeout = status.timeout;
      this.show_status = true;
    });
    this.$webpageEventBus.$off("show_status", () => {
      this.show_status = false;
    });
    this.$webpageEventBus.$on("show_calendar", (status) => {
      this.status.type = status.type;
      this.status.message = status.message;
      this.status.timeout = status.timeout;
      this.show_calendar = true;
    });
    this.$webpageEventBus.$off("show_calendar", () => {
      this.show_calendar = false;
    });
    this.$webpageEventBus.$on("show_campaign", (id) => {
      this.selected_id = id;
      this.show_campaign = true;
    });
    this.$webpageEventBus.$on("close_campaign", () => {
      this.show_campaign = false;
    });
    this.$webpageEventBus.$on("show_marketing_budget", (id) => {
      this.selected_id = id;
      this.show_marketing_budget = true;
    });
    this.$webpageEventBus.$on("close_marketing_budget", () => {
      this.show_marketing_budget = false;
    });
    this.$webpageEventBus.$on("show_memo", (id) => {
      this.selected_id = id;
      this.show_memo = true;
    });
    this.$webpageEventBus.$on("close_memo", () => {
      this.show_memo = false;
    });
    this.$webpageEventBus.$on("show_pdv_calculator", () => {
      this.show_pdv_calculator = true;
    });
    this.$webpageEventBus.$on("close_pdv_calculator", () => {
      this.show_pdv_calculator = false;
    });
  },
};
</script>

<style>
.chart_title {
  font-family: "Open Sans";
}
html,
body {
  height: 100%;
}
</style>
